<template>
  <div>
    <load-profile></load-profile>
    <b-tabs
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
    >
      <!-- v-model="tabIndex" -->
      <!-- general tab -->
      <b-tab>
        <template #title>
          <feather-icon icon="PhoneCallIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t("pages.callCenter.callSettings.callWidget")
          }}</span>
        </template>
        <!-- Add component quick message -->
        <call-widget />
      </b-tab>

      <b-tab>
        <template #title>
          <feather-icon icon="HashIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t("pages.callCenter.callSettings.voiceCommands")
          }}</span>
        </template>
        <!-- Add component call setting -->
        <call-instruction />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BCard, BTab, BTabs, BCardText, BButton } from "bootstrap-vue";
import ChatSettingsRepository from "@/repositories/Api/ChatSettingsRepository";
import callInstruction from "./components/callInstruction/Index.vue";
import callWidget from "./components/callWidget/Index.vue";

export default {
  components: {
    BCard,
    BCardText,
    BButton,
    BTab,
    BTabs,
    callInstruction,
    callWidget,
  },
  watch: {
    "$i18n.locale"() {
      this.translate();
    },
  },
  data: () => ({
    data: [],
    welcomeMessage: {
      id: "",
      title: "",
      desc: "",
      options: {
        enable: false,
        locales: {
          en: "Welcome",
          zh: "",
          km: "",
          vi: "",
        },
      },
    },
    replyFirstMessage: {
      id: "",
      title: "",
      desc: "",
      options: {
        enable: false,
        locales: {
          en: "",
          zh: "",
          km: "",
          vi: "",
        },
      },
    },
    serviceDoesNotAnswer: {
      id: "",
      title: "",
      desc: "",
      options: {
        sendAfter: 60,
        enable: false,
        locales: {
          en: "",
          zh: "",
          km: "",
          vi: "",
        },
      },
    },
    customerUnresponsive: {
      id: "",
      title: "",
      desc: "",
      options: {
        sendAfter: 60,
        enable: false,
        locales: {
          en: "",
          zh: "",
          km: "",
          vi: "",
        },
      },
    },
    endOfConversation: {
      id: "",
      title: "",
      desc: "",
      editorTitle: "",
      options: {
        enable: false,
        locales: {
          en: "",
          zh: "",
          km: "",
          vi: "",
        },
      },
    },
    autoCloseChat: {
      id: "",
      title: "",
      desc: "",
      editorTitle: "",
      options: {
        enable: false,
        closeTime: 60,
        locales: {
          en: "",
          zh: "",
          km: "",
          vi: "",
        },
      },
    },
  }),
  methods: {
    translate() {
      this.welcomeMessage = {
        ...this.welcomeMessage,
        title: this.$t("pages.chatSettings.welcome.title"),
        desc: this.$t("pages.chatSettings.welcome.desc"),
      };
      this.replyFirstMessage = {
        ...this.replyFirstMessage,
        title: this.$t("pages.chatSettings.reply.title"),
        desc: this.$t("pages.chatSettings.reply.desc"),
      };
      this.serviceDoesNotAnswer = {
        ...this.serviceDoesNotAnswer,
        title: this.$t("pages.chatSettings.serviceUnresponsive.title"),
        desc: this.$t("pages.chatSettings.serviceUnresponsive.desc"),
      };
      this.customerUnresponsive = {
        ...this.serviceDoesNotAnswer,
        title: this.$t("pages.chatSettings.customerUnresponsive.title"),
        desc: this.$t("pages.chatSettings.customerUnresponsive.desc"),
      };
      this.endOfConversation = {
        ...this.endOfConversation,
        title: this.$t("pages.chatSettings.endConversation.title"),
        desc: this.$t("pages.chatSettings.endConversation.desc"),
        editorTitle: this.$t("pages.chatSettings.endConversation.editor.title"),
      };
      this.autoCloseChat = {
        ...this.autoCloseChat,
        title: this.$t("pages.chatSettings.autoCloseChat.title"),
        desc: this.$t("pages.chatSettings.autoCloseChat.desc"),
        editorTitle: this.$t("pages.chatSettings.autoCloseChat.editor.title"),
      };
    },
    async getChatSettings() {
      try {
        const response = await ChatSettingsRepository.show();
        const { data } = response.data;
        this.data = data;
        if (this.data.length == 0)
          await ChatSettingsRepository.createDefaultChatSettings();
        this.welcomeMessage = this.mappingData("action.welcomeReply");
        this.replyFirstMessage = this.mappingData("action.firstReply");
        this.serviceDoesNotAnswer = this.mappingData(
          "action.merchantNoResponse"
        );
        this.customerUnresponsive = this.mappingData(
          "action.visitorNoResponse"
        );
        this.endOfConversation = this.mappingData("action.endManual");
        this.autoCloseChat = this.mappingData("action.end");
      } catch (err) {
        const { data } = err.response;
        const { message } = data;
        if (message === "error.recordNotFound")
          await this.createDefaultChatSettings();
      }
    },
    async createDefaultChatSettings() {
      try {
        await ChatSettingsRepository.show();
        await this.getChatSettings();
      } catch (err) {
        alert(err);
      }
    },
    async updateChatSettings(payloadUpdate, id) {
      try {
        const response = await ChatSettingsRepository.update(payloadUpdate, id);
      } catch (err) {
        alert(err);
      } finally {
        await this.getChatSettings();
      }
    },
    async onUpdateEnable(event) {
      let payload = {
        enable: event.enable,
      };
      this.updateChatSettings(payload, event.id);
    },
    async onUpdateTextEditor(event) {
      let payload = {
        notifySend: event.sendAfter ? event.sendAfter : event.closeTime,
        message: event.locales,
      };
      this.updateChatSettings(payload, event.id);
    },
    mappingData(codeAction) {
      let filterData = this.data.filter((item) => {
        return item.code == codeAction;
      });
      let settingMsg = filterData[0];
      let response = {
        id: settingMsg.id,
        title: settingMsg.title,
        desc: settingMsg.description,
        options: {
          enable: settingMsg.enable,
          sendAfter: settingMsg.notifySend,
          locales: {
            en: settingMsg.message.en,
            zh: settingMsg.message.zh,
            km: settingMsg.message.km,
            vi: settingMsg?.message?.vi || null,
          },
        },
      };
      if (codeAction == "action.end") {
        delete response.options.sendAfter;
        response.options.closeTime = settingMsg.notifySend;
      } else if (codeAction == "action.endManual") {
        delete response.options.sendAfter;
      }
      return response;
    },
  },
  mounted() {
    this.translate();
    this.getChatSettings();
  },
  setup() {
    const permissionType = "chat-settings";
    return { permissionType };
  },
};
</script>
